var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NetworkErrorPayload } from "../../../errors/NetworkError";
import { UnknownErrorPayload } from "../../../errors/UnknownError";
import { State } from "../../../hooks/useUseCase";
import { ChangedTabUseCasePayload } from "./usecases/ChangeTabUseCase";
import { ChangedCategoryUseCasePayload } from "./usecases/ChangeCategoryUseCase";
import { ChangedImageUseCasePayload } from "./usecases/ChangeImageUseCase";
import { ChangedPageUseCasePayload } from "./usecases/ChangePageUseCase";
import { ChangedImageDataUrlUseCasePayload } from "./usecases/ChangeImageDataUrlUserCase";
import { ClosedImageInputDialogPayload } from "./usecases/CloseImageInputDialogUseCase";
import { StartedLoadingPayload } from "./usecases/StartLoadingUseCase";
import { FinishedLoadingPayload } from "./usecases/FinishLoadingUseCase";
import { ClosedAlertPayload } from "./usecases/CloseAlertUseCase";
var ImageInputDialogState = /** @class */ (function (_super) {
    __extends(ImageInputDialogState, _super);
    function ImageInputDialogState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.siblingCategories = [];
        _this.contents = [];
        _this.contentsTotal = 0;
        _this.currentPage = 1;
        _this.isLoading = false;
        _this.requiredAlert = undefined;
        return _this;
    }
    ImageInputDialogState.prototype.reduce = function (payload) {
        if (payload instanceof ChangedTabUseCasePayload) {
            this.activeTab = payload.tab;
            this.siblingCategories = [];
            this.contents = [];
            this.contentsTotal = 0;
            this.currentPage = 1;
            this.activeImage = undefined;
            this.imageDataUrl = undefined;
        }
        if (payload instanceof ChangedImageUseCasePayload) {
            this.activeImage = payload.image;
        }
        if (payload instanceof ChangedCategoryUseCasePayload) {
            this.activeImage = undefined;
            this.activeCategory = payload.activeCategory;
            this.siblingCategories = payload.siblingCategories;
            this.contents = payload.contents;
            this.contentsTotal = payload.contentsTotal;
            this.currentPage = 1;
        }
        if (payload instanceof ChangedPageUseCasePayload) {
            this.activeImage = undefined;
            this.currentPage = payload.page;
        }
        if (payload instanceof ChangedImageDataUrlUseCasePayload) {
            this.imageDataUrl = payload.imageDataUrl;
        }
        if (payload instanceof ClosedImageInputDialogPayload) {
            this.activeTab = undefined;
            this.activeImage = undefined;
            this.activeCategory = undefined;
            this.siblingCategories = [];
            this.contents = [];
            this.contentsTotal = 0;
            this.currentPage = 1;
            this.imageDataUrl = undefined;
        }
        if (payload instanceof StartedLoadingPayload) {
            this.isLoading = true;
        }
        if (payload instanceof FinishedLoadingPayload) {
            this.isLoading = false;
        }
        if (payload instanceof NetworkErrorPayload || payload instanceof UnknownErrorPayload) {
            this.requiredAlert = payload.error;
        }
        if (payload instanceof ClosedAlertPayload) {
            this.requiredAlert = undefined;
        }
    };
    return ImageInputDialogState;
}(State));
export { ImageInputDialogState };
